<template>
	<header class="site-header" :class="{ solid: scrolled }">
		<div class="wrap header-inner header-wrap">
			<router-link class="brand" to="/">
				<img v-if="site.logo" :src="site.logo" class="brand-logo" alt="logo" />
				<span class="brand-mark" v-else>HS</span>
				<span class="brand-name">{{ site.companyName || '合肥中科厚生医疗科技有限公司' }}</span>
			</router-link>
			<nav class="nav desktop-nav">
				<router-link v-for="nav in navs" :key="nav.id" :to="nav.path">{{ nav.title }}</router-link>
			</nav>
			<div class="header-actions">
				<button class="icon-btn" @click="searchOpen = true">⌕</button>
				<a class="tel" :href="'tel:' + (site.phone || '')">{{ site.phone || '18600228039' }}</a>
				<button class="menu-btn" @click="mobileOpen = !mobileOpen"><span></span></button>
			</div>
		</div>
		<div class="mobile-panel" :class="{ open: mobileOpen }">
			<router-link v-for="nav in navs" :key="nav.id" :to="nav.path"
				@click.native="mobileOpen = false">{{ nav.title }}</router-link>
		</div>
		<div class="search-modal" v-if="searchOpen">
			<div class="search-box">
				<button class="close" @click="searchOpen = false">×</button>
				<input v-model="keyword" placeholder="请输入搜索关键字..." @keyup.enter="goSearch">
				<button @click="goSearch">搜索</button>
			</div>
		</div>
	</header>
</template>

<script>
	export default {
		props: {
			site: Object,
			navs: Array
		},
		data() {
			return {
				scrolled: false,
				mobileOpen: false,
				searchOpen: false,
				keyword: ''
			}
		},
		mounted() {
			window.addEventListener('scroll', this.onScroll)
			this.onScroll()
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.onScroll)
		},
		methods: {
			onScroll() {
				this.scrolled = window.scrollY > 20
			},
			goSearch() {
				const kw = this.keyword.trim()
				if (!kw) {
					this.searchOpen = false
					return
				}
				this.searchOpen = false
				this.$router.push({
					path: '/news',
					query: {
						keyword: kw
					}
				})
			}
		}
	}
</script>